/** @jsx jsx */
import { jsx, Button } from 'theme-ui'

const NoStyleButton = props => (
  <Button
    {...props}
    type="button"
    variant="smallText"
    sx={{
      color: 'muted',
      backgroundColor: 'transparent',
      fontWeight: 'normal',
      ':hover': { color: 'black' },
      ':focus': { outline: 'none' },
    }}
  />
)

export default NoStyleButton
